// extracted by mini-css-extract-plugin
module.exports = {"loadingSpinner":"styles_loadingSpinner__1STs_","spin":"styles_spin__drpX8"};